
// product media slider
document.addEventListener("DOMContentLoaded", function() {
  var initialIndex = 0;
  var initialIndexEl = document.querySelector("[data-swiper-slider-active-index]");
  if (initialIndexEl) {
    initialIndex = parseInt(initialIndexEl.dataset.swiperSliderActiveIndex) - 1;
  }
  
  var galleryThumbs = new Swiper(".media-slider__thumbs", {
    centeredSlides: true,
    centeredSlidesBounds: true, 
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    breakpoints: {
      480: {
        direction: "vertical",
        slidesPerView: 5,
        spaceBetween: 20,
      }
    }
  });

  var galleryMain = new Swiper(".media-slider__main", {
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 1,
    autoHeight: true,
    initialSlide: initialIndex,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    a11y: {
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
    },
    keyboard: {
      enabled: true,
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });

  galleryMain.on("slideChangeTransitionStart", function () {
    galleryThumbs.slideTo(galleryMain.activeIndex);
  });

  galleryMain.on("slideChangeTransitionEnd", function () {
    setTimeout(() => {
      if (window.recalcTimeline) {
        window.recalcTimeline();
      }
    }, 100);
  });


  galleryThumbs.on("transitionStart", function () {
    galleryMain.slideTo(galleryThumbs.activeIndex);
  });

  // *** Build the variant-to-slide mapping (cached) ***
  var variantToSlideMapping = {};
  var images = document.querySelectorAll('.media-slider__main .swiper-slide');
  images.forEach(function(slide, index) {
    var dataVariant = slide.getAttribute('data-variant-id');
    if (dataVariant) {
      // Split the string by commas and trim each value
      var ids = dataVariant.split(',').map(function(id) {
        return id.trim();
      });
      ids.forEach(function(id) {
        if (variantToSlideMapping[id] === undefined) {
          variantToSlideMapping[id] = index;
        }
      });
    }
  });
  
  // update slider on variant change using the cached mapping
  document.addEventListener("gh_product_variant_changed", function() {
    var variantEl = document.querySelector('select[name="id"]');
    if (!variantEl) return;
    var variantId = variantEl.value.trim();
    var foundIndex = -1;
    var images = document.querySelectorAll('.media-slider__main .swiper-slide');
    images.forEach(function(slide, index) {
      var dataVariant = slide.getAttribute('data-variant-id');
      if (dataVariant) {
        var ids = dataVariant.split(',').map(function(id) {
          return id.trim();
        });
        if (ids.indexOf(variantId) > -1) {
          foundIndex = index;
        }
      }
    });
    
    if (foundIndex >= 0) {
      galleryMain.slideTo(foundIndex);
      if (window.recalcTimeline) {
        window.recalcTimeline();
      }
    }
  });



  // Function to dynamically adjust the height of the thumb slider
  function syncSliderHeight() {
    var mainHeight = document.querySelector('.media-slider__main .swiper-wrapper').offsetHeight;
    var thumbsSliderContainer = document.querySelector('.media-slider__thumbs');
    thumbsSliderContainer.style.height = mainHeight + 'px';
  }
  syncSliderHeight();
  window.addEventListener('resize', syncSliderHeight);
})

window.addEventListener('load', function() {
  if (window.recalcTimeline) {
    window.recalcTimeline();
  }
});

// features slider
document.addEventListener("DOMContentLoaded", function() {
  var featureSlider = document.querySelectorAll(".features-slider__main");
  if (featureSlider) {
    var featureSliderMain = new Swiper(".features-slider__main", {
      direction: "horizontal",
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      keyboard: {
        enabled: true,
      },
      autoplay: {
        delay: 3500,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      }
    });
  }
})

// product options
document.addEventListener("DOMContentLoaded", function() {
  // update master select by name
  function updateMasterSelect(optionName) {
    var select = document.querySelector("select[data-master-select]");
    var options = select.querySelectorAll("option");

    // Find the option with the matching data-name
    var matchingOption = Array.from(options).find(option => option.getAttribute("data-name") === optionName);
    if (matchingOption) {
      select.value = matchingOption.value;
      var event = new Event('change', { bubbles: true });
      select.dispatchEvent(event);
    }
  }

  var options = document.querySelectorAll('.product-form__item.supports-js input[type="radio"]');
  if (options) {
    options.forEach(function(option) {
      option.addEventListener("change", function(e) {
        var optionName = e.target.dataset.name;
        var optionValue = e.target.value;
        var selectTarget = document.querySelector('select[name="'+optionName+'"]');
        
        // update current select
        var event = new Event("change", { bubbles: true });
        selectTarget.value = optionValue;
        selectTarget.dispatchEvent(event);

        // update master select
        var variantName = Array.from(document.querySelectorAll("select.single-option-selector")).map(item => item.value).join(" / ");
        updateMasterSelect(variantName);

        // trigger event for image update
        var varinatChnagedEvent = new Event("gh_product_variant_changed", { bubbles: true });
        document.dispatchEvent(varinatChnagedEvent);
      })
    })
  }
})